import React from 'react';
import {Table as BaseTable} from 'desktop/sports/nhl/players-list/tiers';

class Table extends BaseTable {}

export {Table};
